// godo
export const MY_GODO_URL = 'https://www.nhn-commerce.com/mygodo/myGodo_Domain_change.php';
export const GODO_SECURE_LIST = 'https://www.nhn-commerce.com/mygodo/my_godo_secure_list.php';
export const SECURITY_SERVER = 'https://www.nhn-commerce.com/mygodo/myGodo_shopDomain.php';

// etc
export const PERSONAL_INFO_PROTECTION_ACT =
  'http://www.law.go.kr/법령/개인정보보호법/(20200805,16930,20200204)/제29조)';
export const SHOPBY_HELP_URL = 'https://shopby-help.nhn-commerce.com/';
